export default __webpack_public_path__ + "static/media/logo.66e5fd0f.png";